import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from './firebase';

export function monthlyUpdatePdfStoragePath(userId: string, companyId: string, updateId: string): string {
  return `monthlyUpdatePdfs/${userId}/${companyId}/${updateId}.pdf`;
}

export async function uploadMonthlyUpdatePdf(
  userId: string,
  companyId: string,
  updateId: string,
  file: File
): Promise<{ pdfUrl: string; pdfStoragePath: string }> {
  const pdfStoragePath = monthlyUpdatePdfStoragePath(userId, companyId, updateId);
  const r = ref(storage, pdfStoragePath);
  await uploadBytes(r, file, { contentType: file.type || 'application/pdf' });
  const pdfUrl = await getDownloadURL(r);
  return { pdfUrl, pdfStoragePath };
}

export async function deleteMonthlyUpdatePdf(pdfStoragePath: string | undefined): Promise<void> {
  if (!pdfStoragePath) return;
  try {
    await deleteObject(ref(storage, pdfStoragePath));
  } catch {
    /* ignore missing object */
  }
}
